import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { isPaymentCollectionsReconciliationRequest } from '@core/reconciliation-api-url';
import { TenantService } from '@core/services/tenant.service';
import { PUBLIC_REQUEST } from './public-request.token';

export const contractIdInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.context.get(PUBLIC_REQUEST)) {
    return next(req);
  }

  if (!isPaymentCollectionsReconciliationRequest(req.url)) {
    return next(req);
  }

  const tenantKey = inject(TenantService).tenantKey();

  if (!tenantKey) {
    return next(req);
  }

  return next(req.clone({
    setHeaders: { 'x-contract-id': tenantKey }
  }));
};
